// Corregir voz desde el lienzo — ADR-2026-09-24-corregir-voz-en-la-barra-del-lienzo.
//
// La MISMA sheet de Creaciones (`CorregirVozSheet`): transcribe el video, el usuario toca
// la palabra y escribe cómo tenía que decir, y el backend guarda un video NUEVO (gratis).
// Lo nuevo entra por `onImagenNueva`, como la Expansión: el lienzo lo cuelga debajo del
// video de origen.

import { useEffect } from 'react';
import CorregirVozSheet from '../../../components/CorregirVozSheet';
import type { PropsDeHerramienta } from './herramienta';

export const PanelCorregirVoz: React.FC<PropsDeHerramienta> = ({ celda, ratio, onCerrar, onImagenNueva, onError }) => {
  const fileName = celda.datos.fileName;
  useEffect(() => {
    if (fileName) return;
    onError('No pudimos abrir este video.');
    onCerrar();
  }, [fileName, onError, onCerrar]);
  if (!fileName) return null;
  return (
    <CorregirVozSheet
      abierto
      video={{ id: celda.imageId, fileName }}
      companyId={celda.companyId}
      onCerrar={onCerrar}
      onListo={(nuevo) => {
        onImagenNueva({ id: nuevo.id, origenId: celda.imageId, ratio, producto: celda.titulo, esVideo: true });
        onCerrar();
      }}
    />
  );
};
